import { ReactElement } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BuildUrl } from "../data/usecase/build-url";
import { AnalyticsTracker } from "../presentation/components/analytics/analytics-tracker";
import { Home } from "../presentation/components/home/home";
import { CadastroSucesso } from "../presentation/pages/cadastro-sucesso/cadastro-sucesso";
import { NotFound } from "../presentation/pages/not-found/not-found";
import "./app.css";
import { makeApiLoadFranchise } from "./helper/factories/api-load-franchise";

const apiUrl = String(process.env.REACT_APP_BASEURL);
const loadFranchise = makeApiLoadFranchise();
const urlBuilder = new BuildUrl();

function App(): ReactElement {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              loadFranchise={loadFranchise}
              apiUrl={apiUrl}
              urlBuilder={urlBuilder}
            />
          }
        />
        <Route path="/cadastro-sucesso" element={<CadastroSucesso />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
